import { getErrorMessage } from "@strtmn/strtmn"
import { useEffect, useState } from "react"
import { getCurrentTermsVersion } from "../api/EuDataActApi"
import { getLinkToEuDataActTerms } from "../LinkUtils"

/** The current version of the EU Data Act terms (DNV), and the link to them. */
export const useCurrentTerms = (userPrefLang = "de") => {
  const [termsVersion, setTermsVersion] = useState<string | undefined>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | undefined>()

  useEffect(() => {
    let isCancelled = false
    const load = async () => {
      try {
        const version = await getCurrentTermsVersion()
        if (!isCancelled && version) {
          setTermsVersion(version)
        }
      } catch (err) {
        console.error("useCurrentTerms: Error", err)
        if (!isCancelled) {
          setError(getErrorMessage(err))
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false)
        }
      }
    }
    load()
    return () => {
      isCancelled = true
    }
  }, [])

  const termsUrl = termsVersion
    ? getLinkToEuDataActTerms(termsVersion, userPrefLang)
    : undefined
  return { termsVersion, termsUrl, isLoading, error }
}
